import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=3e45a4ac&scoped=true&"
import script from "./TagsView.vue?vue&type=script&lang=js&"
export * from "./TagsView.vue?vue&type=script&lang=js&"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=3e45a4ac&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./TagsView.vue?vue&type=style&index=1&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e45a4ac",
  null
  
)

component.options.__file = "TagsView.vue"
export default component.exports